<template>
  <div class="resend-countdown">
    <button
      v-if="remaining <= 0"
      type="button"
      class="btn btn-link resend-countdown__btn"
      :disabled="disabled"
      @click="$emit('resend')">
      Reenviar código
    </button>
    <span v-else class="resend-countdown__counter">
      Reenviar em {{ remaining }}s
    </span>
  </div>
</template>

<script>
export default {
  name: 'ResendCountdown',
  props: {
    /** Initial countdown in seconds; reset by parent on each new issue. */
    initial: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      remaining: 0,
      intervalId: null
    }
  },
  watch: {
    /**
     * When the parent receives a fresh ``resend_available_in_seconds``
     * (initial issue or successful resend) we restart the countdown.
     * Without this watcher the timer would only honour the first value
     * the component ever sees.
     */
    initial: {
      immediate: true,
      handler (value) {
        this.start(value || 0)
      }
    }
  },
  beforeDestroy () {
    this.stop()
  },
  methods: {
    /** Begin counting down from ``seconds``; clears any prior interval. */
    start (seconds) {
      this.stop()
      this.remaining = seconds
      if (seconds <= 0) {
        return
      }
      this.intervalId = setInterval(() => {
        this.remaining -= 1
        if (this.remaining <= 0) {
          this.stop()
        }
      }, 1000)
    },
    /** Halt the countdown without zeroing the visible remaining. */
    stop () {
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    }
  }
}
</script>

<style scoped>
.resend-countdown {
  text-align: center;
  margin-top: 12px;
}
.resend-countdown__btn {
  padding: 0;
}
.resend-countdown__counter {
  color: #999;
  font-size: 13px;
}
</style>
